import { AutomaticActionEnum } from "@/main/services/enum/AutomaticActionEnum";

export enum AutomaticActionsTypes {
	GET_AUTOMATIC_ACTION = "@automaticAction/GET_AUTOMATIC_ACTION",
	SAVE_AUTOMATIC_ACTION = "@automaticAction/SAVE_AUTOMATIC_ACTION",
	RESET_REDUCER_BY_AUTOMATIC_ACTION_ENUM_ACTION = "@automaticAction/RESET_REDUCER_BY_AUTOMATIC_ACTION_ENUM_ACTION",
	RESET_REDUCER_BY_ID_ACTION = "@automaticAction/RESET_REDUCER_BY_ID_ACTION",
	RESET_ALL_REDUCER_ACTION = "@automaticAction/RESET_ALL_REDUCER_ACTION",
}

export type AutomaticActionData = {
	idAction: AutomaticActionEnum;
	id: string;
	data?: any;
};

export interface AutomaticActionState {
	readonly automaticAction: {
		data: AutomaticActionData[] | null;
	};
}

export interface GetAutomaticAction {
	type: typeof AutomaticActionsTypes.GET_AUTOMATIC_ACTION;
}

export interface SaveAutomaticAction {
	type: typeof AutomaticActionsTypes.SAVE_AUTOMATIC_ACTION;
	payload: {
		data: AutomaticActionData;
	};
}

export interface ResetReducerByAutomaticActionEnumAction {
	type: typeof AutomaticActionsTypes.RESET_REDUCER_BY_AUTOMATIC_ACTION_ENUM_ACTION;
	payload: {
		action: AutomaticActionEnum;
	};
}

export interface ResetReducerByIdAction {
	type: typeof AutomaticActionsTypes.RESET_REDUCER_BY_ID_ACTION;
	payload: {
		action: string;
	};
}
export interface ResetAllReducerAction {
	type: typeof AutomaticActionsTypes.RESET_ALL_REDUCER_ACTION;
}

export type AutomaticActionActionTypes =
	| GetAutomaticAction
	| SaveAutomaticAction
	| ResetReducerByAutomaticActionEnumAction
	| ResetReducerByIdAction
	| ResetAllReducerAction;
